/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WardApi } from '../api/ward.api';
import { switchMap, map } from 'rxjs/operators';
import { WardData, Ward } from '../../../interfaces/masters/ward';

@Injectable()
export class WardService extends WardData {

  constructor(private api: WardApi) {
    super();
  }


  list(url: string): Observable<Ward[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Ward>{
      return this.api.getById(url);
  }

  create(url: string, data:Ward): Observable<Ward[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Ward): Observable<Ward> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
